// extracted by mini-css-extract-plugin
export default {"container":"JobActivities_container__r2AQh","noDataAvailable":"JobActivities_noDataAvailable__4wSmc"};